/**
 * Primary action handlers must never fail silently — surface a visible error + retry path.
 */

export function formatPrimaryActionError(actionLabel, reason) {
  const label = String(actionLabel || 'complete action').trim();
  const detail = String(reason || 'Unknown error')
    .replace(/^API \d+:\s*/i, '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 200);
  return `Couldn't ${label} — ${detail}`;
}

/**
 * @param {{
 *   actionLabel: string;
 *   run: () => void | Promise<void>;
 *   onError?: (message: string | null) => void;
 *   onRunning?: (busy: boolean) => void;
 * }} opts
 * @returns {Promise<boolean>} true when the action completed without throwing
 */
export async function runPrimaryAction({ actionLabel, run, onError, onRunning }) {
  onError?.(null);
  onRunning?.(true);
  try {
    await run();
    return true;
  } catch (err) {
    onError?.(formatPrimaryActionError(actionLabel, err?.message || err));
    return false;
  } finally {
    onRunning?.(false);
  }
}
